<template>
  <div>
    <dl v-for="(item,index) in studylist" :data-id="index" :key="index">
      <dt>
        <span>
          <i>{{item.day[0]}}年</i>
          {{item.day[1]}}月{{item.day[2]}}日
        </span>
      </dt>
      <dd v-for="(itemson) in item.origin" :data-id="itemson.id" :key="itemson.id" @click='jumps(itemson.video.id,itemson.video.type,itemson.isDelete)'>
        <div class="classitems clearfix">
          <div class="pic fl">
            <img :src="itemson.video.image" alt />
            <div class="type" v-if="itemson.video.type==1">点播课</div>
            <div class="type" v-if="itemson.video.type==2">直播课</div>
            <div class="type" v-if="itemson.video.type==3">线下课</div>
          </div>
          <div class="infos clearfix fr">
            <h3>{{itemson.video.title}}</h3>
            <div class="zai">
              <i class="el-icon-s-custom"></i>
              {{itemson.AllUserLearnCount}}人在学
            </div>
            <div class="ke">
              <span>
                <i class="el-icon-caret-right"></i>
              </span>
              {{itemson.video.section_title}}
            </div>
          </div>
        </div>
      </dd>
    </dl>
  </div>
</template>

<script>
import { Message } from "element-ui";
import utilFile from "@/ace/ace.js";
export default {
  components: {
    [Message.name]: Message
  },
  data() {
    return {
      page: 1,
      studylist: []
    };
  },
  watch: {
    activeName(newvalue) {
      this.studylist = [];
      this.collection(newvalue);
    }
  },
  methods: {
    dayqiege(day) {
      return day.split("-");
    },
    jumps(id, type, isDelete) {
      if (isDelete != undefined && isDelete == 1) {
        Message.closeAll();
        Message({
          message: '该课程已被下架',
          type: 'warning'
        });
      } else {
        this.$router.push({
          path: "/detailsclass",
          query: {
            id,
          }
        });
      }
    },
    onClose(id) {
      var data = utilFile.encrypt(
        JSON.stringify({
          learn_id: id
        })
      );

      this.$axios({
        method: "post",
        url: `/api/user.delLearn?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 200) {
          Message.closeAll();
          Message({
            showClose: true,
            message: res.data.msg,
            type: "success"
          });
          this.studylist.forEach((item, index) => {
            if (item.id == id) {
              this.studylist.splice(index, 1);
            }
          });
        }
      });
    },
    study(type) {
      var data = utilFile.encrypt(
        JSON.stringify({
          page: this.page,
          type
        })
      );

      this.$axios({
        method: "post",
        url: `/api/user.getLearnList?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 999) {
          this.$router.push({
            path: "/logins"
          });
        } else {
          if (res.data.data != undefined) {
            let arr = JSON.parse(utilFile.decrypt(res.data.data));

            let tempArr = [];
            arr.forEach((item, index) => {
              if (tempArr.indexOf(item.day) == -1) {
                this.studylist.push({
                  day: item.day,
                  origin: [arr[index]]
                });
                tempArr.push(arr[index].day);
              } else {
                for (let j = 0; j < this.studylist.length; j++) {
                  if (this.studylist[j].day == item.day) {
                    this.studylist[j].origin.push(item);
                  }
                }
              }
            });
            this.studylist.forEach(item => {
              item.day = this.dayqiege(item.day);
            });

          }
        }
      });
    }
  },
  mounted() {
    this.study();
  }
};
</script>

<style scoped>
dl dt {
  font-size: 24px;
  color: #000000;
  position: relative;
  box-sizing: border-box;
  padding-left: 34px;
  margin-top: 43px;
  margin-bottom: 24px;
}
dl dt i {
  font-size: 18px;
  color: #878787;
  margin-right: 9px;
}

dl dt::after {
  display: block;
  width: 14px;
  content: "";
  height: 14px;
  border-radius: 50%;
  background-color: #38a0ff;
  position: absolute;
  left: 5px;
  bottom: 5px;
}

dl dt::before {
  width: 100%;
  content: "";
  height: 1px;
  background-color: #edf1f2;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 10;
}

dl dt span {
  padding-right: 26px;
  position: relative;
  z-index: 100;
  background-color: #ffffff;
}

.classitems {
  padding: 25px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #edf1f2;
}
.classitems .pic {
  width: 210px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  height: 120px;
}

.classitems .pic img{
  min-height: 100%;
}

.classitems .pic .type {
  position: absolute;
  font-size: 14px;
  color: #ffffff;
  padding: 7px 12px;
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.6);
  left: 10px;
  top: 10px;
}

.classitems .infos {
  width: 690px;
  text-align: left;
}

.classitems .infos h3 {
  font-size: 18px;
  color: #000000;
  margin-bottom: 16px;
  margin-top: 9px;
}

.classitems .infos .zai {
  font-size: 14px;
  color: #878787;
  margin-bottom: 30px;
}

.classitems .infos .zai i {
  color: #878787;
}

.classitems .hou {
  width: 100%;
}

.classitems .ke {
  font-size: 15px;
  color: #575c4c;
  margin-top: 56px;
}

.classitems span {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-color: #9199a1;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
}

.classitems span i {
  color: #ffffff;
  font-size: 16px;
}
dl {
  cursor: pointer;
}
</style>